import CalendarViewTile from './CalendarViewTile.vue';

export default CalendarViewTile;
